export enum DashboardSortType {
  TotalVolume = "totalVolume",
  Volume24 = "volume24",
  Liquidity = "liquidity",
  Newest = "newest",
  EndingSoon = "endingSoon",
  Consensus = "consensus",
  TightestSpread = "tightestSpread",
  WidestSpread = "widestSpread",
}
